/**
 * 根据是否显示价格，给列表排序
 */
export function sortRecommendList(list = []){
  list.sort((r1,r2)=>{
    let v1 = r1.priceDisplayType;
    let v2 = r2.priceDisplayType;
    if(v1 === v2) return 0;
    if(v1 === 2) return -1;
    if(v2 === 2) return 1;
  });
}



//////////////////
// WEBPACK FOOTER
// ./common/priceBlurring/utils.js
// module id = X9PL
// module chunks = 36